import { useCallback } from "react";
// import useAxios from "@Apis/useAxios";
// import { POST_PRINT_API } from "@Apis/apiPath";
import { useSnackbar } from "notistack";

const usePrintApi = () => {
	// const Axios = useAxios();
	const { enqueueSnackbar } = useSnackbar();

	const postPrintApi = useCallback(
		async uri => {
			// const resp = await Axios.post(POST_PRINT_API, { uri });
			const resp = {
				isError: true,
				message: "test",
			};
			if (resp && resp.isError) {
				enqueueSnackbar(resp.message, { variant: "error" });
			}
		},
		// eslint-disable-next-line
		[]
	);

	return { postPrintApi };
};

export default usePrintApi;
